import React, { useState, useContext, useCallback } from 'react';
import { Fragment } from 'react/cjs/react.production.min';
import { Modal } from '../../Component/Modal/Modal';
import { styleContextApp } from '../StyleContext';
import { CloseButton, ConfirmButton, MainTextTitle, ReserveModalWrapper, SubTextTitle, TextFieldWrapper, TextItemInput, TextItemTitle, TextItemWrapper, MobileButtomDialog } from './ReserveModalStyle';
import { Input } from '@arco-design/web-react';
import closepic from './close.png';
import { STYLE_TYPE } from '../../Utils/magicStrings';
import { useNavigate } from 'react-router-dom';


export const ReserveModal = (props) => {
    const [ hasError, setHasError ] = useState(false);
    const [ hasRequired, setHasRequired ] = useState(false);
    const styleType = useContext(styleContextApp);
    const [ tele, setTele ] = useState(props.tele);
    const [ email, setEmail ] = useState(props.email);
    const [ line, setLine ] = useState(props.line);
    const [ name, setName ] = useState(props.name);
    const [ wechat, setWechat ] = useState(props.wechat);
    const  navigate  = useNavigate();
    const innId = props.innId;
    const confirmClick = async () => {
        if((!tele && !email && !line && !wechat) || !name) {
            if((!tele && !email && !line && !wechat) ) { 
                setHasError(true);
            } 
            if(!name) {
                setHasRequired(true);
            }
        } else {
            const { reserveDate, roomNumber, peopleNumber, plan, coverImgUrl, content } = props;
            setHasError(false);
            setHasRequired(false);
            navigate('/confirm', {state: {plan, reserveDate, roomNumber, peopleNumber, tele, email, name, coverImgUrl, content, line, wechat, innId}})
        }
    };

    const tableElements = (
    <ReserveModalWrapper styleType={styleType}>
        <CloseButton styleType={styleType} onClick={()=>{props.setShowReserveModal(false)}}>
            <img src={closepic} alt=''/>
        </CloseButton>
        <MainTextTitle styleType={styleType} isError={hasError}>
            {hasError ? '您有未填选项': '最后一步，输入您的联系方式'}
        </MainTextTitle>
        {!hasError && <SubTextTitle styleType={styleType}>
        注意⚠️：前4项至少选填一项
        </SubTextTitle>}
        <TextFieldWrapper styleType={styleType}>
            <TextItemWrapper styleType={styleType}>
                <TextItemTitle styleType={styleType}>
                    联系电话
                    {hasError && 
                        <Fragment>
                            <span id='point' />
                            <span id='text'>至少选填一项</span>
                        </Fragment>
                    }
                </TextItemTitle>
                <TextItemInput styleType={styleType}>
                    <Input  value={tele} onChange={(e) => {
                        setTele(e);
                    }} style={{width: '100%', height: '100%', background: '#DBDBDB'}}/>
                </TextItemInput>
            </TextItemWrapper>
            <TextItemWrapper styleType={styleType}>
                <TextItemTitle styleType={styleType}>
                    邮箱地址
                    {hasError && 
                        <Fragment>
                            <span id='point' />
                            <span id='text'>至少选填一项</span>
                        </Fragment>
                    }
                </TextItemTitle>
                <TextItemInput styleType={styleType}>
                    <Input  value={email} onChange={(e) => {
                        setEmail(e);
                    }} style={{width: '100%', height: '100%', background: '#DBDBDB'}}/>
                </TextItemInput>
            </TextItemWrapper>
            <TextItemWrapper styleType={styleType}>
                <TextItemTitle styleType={styleType}>
                    LINE
                    {hasError && 
                        <Fragment>
                            <span id='point' />
                            <span id='text'>至少选填一项</span>
                        </Fragment>
                    }
                </TextItemTitle>
                <TextItemInput styleType={styleType}>
                    <Input value={line} onChange={(e) => {
                        setLine(e);
                    }} style={{width: '100%', height: '100%', background: '#DBDBDB'}}/>
                </TextItemInput>
            </TextItemWrapper>
            <TextItemWrapper styleType={styleType}>
                <TextItemTitle styleType={styleType}>
                    微信号
                    {hasError && 
                        <Fragment>
                            <span id='point' />
                            <span id='text'>至少选填一项</span>
                        </Fragment>
                    }
                </TextItemTitle>
                <TextItemInput styleType={styleType}>
                    <Input  value={wechat}  onChange={(e) => {
                        setWechat(e);
                    }} style={{width: '100%', height: '100%', background: '#DBDBDB'}}/>
                </TextItemInput>
            </TextItemWrapper>
            <TextItemWrapper styleType={styleType}>
                <TextItemTitle styleType={styleType} hasText={!hasRequired}>
                    联系人姓名
                    {hasRequired && 
                        <Fragment>
                            <span id='point' />
                            <span id='text'>必填项</span>
                        </Fragment>
                    }
                    {
                        !hasRequired && 
                            <Fragment>
                                <span id='point' />
                                <span id='text'>必填项</span>
                            </Fragment>
                    }
                </TextItemTitle>
                <TextItemInput styleType={styleType}>
                    <Input  value={name} onChange={(e) => {
                        setName(e);
                    }}  style={{width: '100%', height: '100%', background: '#DBDBDB'}}/>
                </TextItemInput>
            </TextItemWrapper>
        </TextFieldWrapper>
        <ConfirmButton styleType={styleType} onClick={confirmClick}>
                确认提交
        </ConfirmButton>
    </ReserveModalWrapper>);

    return (
        <Fragment>
            { styleType !== STYLE_TYPE.MOBILE && <Modal styleType={styleType} positionType={'middle'} modalElement={tableElements} />}
            { styleType === STYLE_TYPE.MOBILE && 
                (
                <Fragment>
                    <div style={{position: 'fixed', width: '100%', height: '100%', top: 0, left:0, background: `rgba(0,0,0,0.67)`, zIndex: 99}}/>
                    <MobileButtomDialog styleType={styleType}>
                    {tableElements}
                    </MobileButtomDialog>
                </Fragment>)}
        </Fragment>
    );
};

